// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@guestsupply/XDL/Utilities";
import { headerStyles } from "@insite/content-library/Widgets/MyLists/MyListsHeader";
import { css } from "styled-components";

headerStyles.container = {
    gap: 15,
    css: css`
        padding-bottom: 20px;
        position: relative;
    `,
};

// Title
headerStyles.leftTopGridItem = {
    width: 10,
};

// Search field
headerStyles.leftBottomGridItem = {
    width: [12, 6, 4, 5, 5],
    css: css`
        > div {
            max-width: 315px;
            ${xScreen("lte", "sm")} {
                max-width: 100%;
            }
            ${xScreen("lte", "xs")} {
                padding-bottom: 5px;
            }
        }
    `,
};

// Sort field
headerStyles.rightBottomGridItem = {
    width: [12, 6, 4, 4, 4],
    css: css`
        > div {
            max-width: 200px;
            margin-left: 10px;
            ${xScreen("lte", "md")} {
                margin-left: 24px;
            }
            ${xScreen("lte", "sm")} {
                max-width: 100%;
                margin-left: 0;
            }
        }
    `,
};

// OverflowMenu
headerStyles.rightTopGridItem = {
    width: [2, 2, 4, 3, 3],
    css: css`
        order: 3;
        ${xScreen("lte", "sm")} {
            order: 0;
        }
    `,
};
